import { AlertLineReportNoteDTO } from "../../models/alert-line-report-note/alert-line-report-note-dto";
import { STOModel } from "../../models/base/sto-model";
import { BaseApiService } from "../base";

export class AlertLineReportNoteFileReviewApiService extends BaseApiService<AlertLineReportNoteDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/SaveAlertLineReportNoteFileReview",
      saveItemsPath: "/",
    });
  }
}
